import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { ProgressBarModule } from './components/elements/progress-bar/progress-bar.module';

import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CookieService } from 'ngx-cookie-service';
import { SnackbarModule as NgxSnackBar } from 'ngx-snackbar';
import { AppComponent } from './app.component';
import { ActionModalModule } from './components/modals/action-modal/action-modal.module';
import { SnackbarModule } from './components/snackbar/snackbar.module';
import { ErrorInterceptor } from './helper/error.interceptor';
import { JwtInterceptor } from './helper/jwt.interceptor';

import ptBr from '@angular/common/locales/pt';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AppRoutingModule } from './app-routing.module';
import { IosInstructionBannerModule } from './components/ios-instruction-banner/ios-instruction-banner.module';
import { LayoutsModule } from './components/layouts/layouts.module';
import { MessageAlertModule } from './components/message-alert/message-alert.module';
import { StorageService } from './helper/storage';

import { SlickCarouselModule } from 'ngx-slick-carousel';
import { SharedModule } from 'src/app/components/shared/shared.module';

import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getMessaging, provideMessaging } from '@angular/fire/messaging';

import { ServiceWorkerModule } from '@angular/service-worker';
import { firebaseConfig } from 'src/firebase-config';
import { environment } from '../environments/environment';

registerLocaleData(ptBr);
@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    LayoutsModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ProgressBarModule,
    ActionModalModule,
    SnackbarModule,
    NgxSnackBar,
    NgxSnackBar.forRoot(),
    MessageAlertModule,
    IosInstructionBannerModule,
    SharedModule,
    SlickCarouselModule,
    provideFirebaseApp(() => initializeApp(firebaseConfig)),
    provideMessaging(() => getMessaging()),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
    //AngularFireModule.initializeApp(firebaseConfig),
    //AngularFireMessagingModule
  ],
  providers: [
    Location,
    CookieService,
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: LOCALE_ID,
      useValue: 'pt',
    },
    StorageService,
    BsModalService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
